<template>
  <BasePopup
    :show="show"
    @close="$emit('close')"
  >
    <div class="barcode-popup-content">
      <div class="barcode-display">
        <img :src="`/api/barcode/${serialNumber}`" alt="條碼" class="barcode-image">
      </div>

      <div class="barcode-serial-section">
        <span class="barcode-serial-text">{{ serialNumber }}</span>
        <CopyButton
          :text="serialNumber"
          variant="barcode"
          success-message="序號已複製到剪貼簿"
          @copied="$emit('copied', $event)"
        />
      </div>
    </div>
  </BasePopup>
</template>

<script>
import BasePopup from '@/components/Page/Web/PartnerMarketing/BasePopup.vue'
import CopyButton from '@/components/Page/Web/PartnerMarketing/CopyButton.vue'

export default {
  name: 'BarcodePopup',
  components: { BasePopup, CopyButton },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    serialNumber: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.barcode-display {
  padding: 20px 0;
  margin-bottom: 16px;
  text-align: center;

  .barcode-image {
    max-width: 100%;
    height: auto;
  }
}

.barcode-serial-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;

  .barcode-serial-text {
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
    color: #333;
    flex: 1;
    white-space: nowrap;
  }
}
</style>